import React from "react";
import { Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

const RevenueTrendChart = ({ chartData = {} }) => {
  const { t } = useTranslation();

  const categories = chartData.categories && chartData.categories.length > 0
    ? chartData.categories
    : ["01 Aug", "05 Aug", "10 Aug", "15 Aug", "20 Aug", "25 Aug", "30 Aug"];

  const series = chartData.series && chartData.series.length > 0
    ? chartData.series
    : [
        { name: "Gross Revenue (₹)", data: [12000, 18500, 24000, 31000, 42000, 49000, 58000] },
        { name: "Collections (₹)", data: [10000, 15000, 22000, 28000, 38000, 44000, 51000] },
        { name: "Pending Dues (₹)", data: [2000, 3500, 2000, 3000, 4000, 5000, 7000] }
      ];

  const options = {
    chart: {
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: "inherit"
    },
    colors: ["#556ee6", "#34c38f", "#f46a6a"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100]
      }
    },
    xaxis: {
      categories: categories,
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        style: { fontSize: "11px", colors: "#74788d" }
      }
    },
    yaxis: {
      labels: {
        formatter: (val) => (val !== undefined && val !== null ? `₹${Number(val).toLocaleString("en-IN")}` : "₹0"),
        style: { fontSize: "11px", colors: "#74788d" }
      }
    },
    tooltip: {
      y: {
        formatter: (val) => (val !== undefined && val !== null ? `₹${Number(val).toLocaleString("en-IN")}` : "₹0")
      }
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      fontSize: "12px",
      markers: { radius: 12 }
    },
    grid: {
      borderColor: "#f1f1f1",
      strokeDashArray: 3
    }
  };

  return (
    <Card className="border-0 shadow-sm mb-4 h-100">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
          <div className="d-flex align-items-center">
            <div className="avatar-xs me-2">
              <span className="avatar-title rounded bg-soft-primary text-primary font-size-16">
                <i className="bx bx-line-chart" />
              </span>
            </div>
            <div>
              <h5 className="card-title mb-0 font-size-15 fw-bold">
                {t("Financial Velocity & Collections Trajectory")}
              </h5>
              <div className="text-muted font-size-11">
                {t("Revenue billed vs realized receipts vs pending dues")}
              </div>
            </div>
          </div>
        </div>

        <div className="apex-charts">
          <ReactApexChart options={options} series={series} type="area" height={280} />
        </div>
      </CardBody>
    </Card>
  );
};

export default RevenueTrendChart;
